import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
// Imported by PATH, not through `containers/index.js`. That barrel re-exports every
// container, so pulling one name through it made CallingAgora — and therefore the
// 1.55 MB Agora SDK — statically reachable from this module, which is rendered at boot.
// It defeated the route splitting in AppRoutes entirely.
import SignIn from '../../containers/SignIn/SignIn';
import AppRoutes from './AppRoutes';
import { useSelector } from 'react-redux';
import { AppLockListener } from '../../components/ApplockListner';
import Storage from '../storage';

const AuthRoutes = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.AppReducer?.user?.data);
  useEffect(() => {
    const Params = window.location.search;
    if (user?.auth_token) {
      if (user?.status === 0) {
        // dispatch(MsgAction.LoadingSet(true));
        navigate('/change-password');
        // dispatch(MsgAction.LoadingSet(false));
        return; // ✅ stop further checks
      }

      if (Params?.includes('_branch_match_id')) {
        // dispatch(MsgAction.LoadingSet(false));
        // navigate(`/join-groups/${Params}`);
        return;
      }

      // An authenticated session stays on whatever URL it is on. This used to
      // navigate to /messages once document.readyState hit 'complete', which
      // fires on every reload — so refreshing /settings/profile (or any other
      // page, or a conversation deep link) threw the user back to the chat list.
      // Landing on messages after signing in is handled where it belongs: the
      // sign-in screen navigates there, and AppRoutes redirects "/" to it.
      return undefined;
    } else {
      /**
       * Remember where they were going before bouncing them to sign-in.
       *
       * Without this the destination was simply lost: an unauthenticated visitor was
       * redirected to `/`, signed in, and landed on `/messages` with no sign that the
       * thing they clicked existed. That breaks every deep link in the product — a note
       * shared with them, a conversation URL, a notification opened on a cold start — and
       * the only way through was to click the original link a second time.
       *
       * `SignIn` consumes this after a successful login. Storage rejects anything that is
       * not a same-origin path, so this cannot become an open redirect.
       */
      Storage.setPostLoginRedirect(window.location.pathname + window.location.search);
      navigate('/');
    }
  }, [user, navigate]);

  // useEffect(() => {
  //   let Params = window.location.search;
  //   if (user?.auth_token) {
  //     if (user?.status === 0) {
  //       // dispatch(MsgAction.LoadingSet(true));
  //       navigate("/change-password");
  //       // dispatch(MsgAction.LoadingSet(false));
  //     } else if (Params?.includes("_branch_match_id")) {
  //       // dispatch(MsgAction.LoadingSet(false));
  //       // navigate(`/join-groups/${Params}`);
  //     }
  //     // else if (user?.status === 1) {
  //     //   navigate("/profile");
  //     // }
  //     else {
  //       document.addEventListener("readystatechange", () => {

  //         if (document.readyState === "loading") {
  //         }

  //         if (document.readyState === "interactive") {
  //         }

  //         if (document.readyState === "complete") {
  //         }
  //       });
  //       if (document.readyState === "loading") {  //       } else {
  //         navigate("/profile");
  //       }
  //       // dispatch(MsgAction.LoadingSet(false));
  //     }
  //   } else {
  //     dispatch(MsgAction.LoadingSet(true));
  //     navigate("/");
  //   }
  // }, [user]);

  // useEffect(() => {
  //   let Params = window.location.search;
  //   if (user?.auth_token) {
  //     if (user?.status === 0) {
  //       // dispatch(MsgAction.LoadingSet(true));
  //       navigate("/change-password");
  //       // dispatch(MsgAction.LoadingSet(false));
  //     } else if (Params?.includes("_branch_match_id")) {
  //       // dispatch(MsgAction.LoadingSet(false));
  //       // navigate(`/join-groups/${Params}`);
  //     }

  //     else {
  //         navigate("/profile");
  //     }
  //   } else {
  //     navigate("/");
  //   }
  // }, []);

  // const handleDeepRoute = async (user) => {
  //   let Params = window.location.search;
  //   let GroupData = await cookieStore.get("_branch_match_id")?.value;
  //   let IfDeepData = Params || GroupData?.value || "";
  //   if (user?.status === 0) {
  //     navigate("/web/change-password");
  //   } else if (IfDeepData?.includes("_branch_match_id")) {
  //     navigate(`/web/join-groups/${IfDeepData}`);
  //   }
  // };

  return (
    <>
      {!user?.auth_token ? (
        /**
         * Signed out, every path shows sign-in.
         *
         * This was `path="/:?"`, which is not a path — `:?` declares a dynamic
         * segment with no name, and React Router's compiler only recognises
         * `/:` followed by word characters. The `?` fell through to the
         * generated regex as a quantifier, which is the only reason `/` matched
         * at all. Nothing else did: signing out anywhere other than the root
         * left `<Routes>` with no match, rendering NOTHING — a black screen at
         * the URL you signed out from, with no way to reach the login form
         * short of editing the address bar.
         *
         * The fragment around the route is gone too: `<Routes>` reads its
         * children to build the route table and only understands `<Route>`.
         */
        <Routes>
          <Route path="*" element={<SignIn />} />
        </Routes>
      ) : (
        <AppLockListener>
          <AppRoutes />
        </AppLockListener>
      )}
    </>
  );
};

export default AuthRoutes;
